import React, { ComponentPropsWithoutRef } from "react"
import PrimaryButton from "../atoms/buttons/PrimaryButton"
import { AddIcon } from "../atoms/icons/AddIcon"
import { AnimatePresence } from "framer-motion"
import Modal from "./Modals/Modal"
import InviteMembertoSuborgModalContent from "./Modals/InviteMemberToSuborgModalContent"
import { useMyOrganization } from "../../hooks/useMyOrganization"

type Props = Partial<ComponentPropsWithoutRef<typeof PrimaryButton>> & {
  orgName?: string
  orgId?: number | string
}

const InviteMemberToOrganizationButton: React.FC<Props> = ({ orgName, orgId, ...props }) => {
  const [inviteMemberOpen, setInviteMemberOpen] = React.useState(false)
  const { myOrganization } = useMyOrganization()

  return (
    <>
      <PrimaryButton
        title="Invite new member"
        icon={<AddIcon />}
        {...props}
        onClick={() => setInviteMemberOpen(true)}
      />
      <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
        {inviteMemberOpen && (
          <Modal open={inviteMemberOpen} onClose={() => setInviteMemberOpen(!inviteMemberOpen)} closeIcon>
            <InviteMembertoSuborgModalContent
              orgName={orgName !== undefined ? orgName : myOrganization?.name!}
              orgId={
                orgId !== undefined
                  ? typeof orgId === "string"
                    ? parseInt(orgId)
                    : orgId
                  : parseInt(myOrganization?.id!)
              }
            />
          </Modal>
        )}
      </AnimatePresence>
    </>
  )
}

export default InviteMemberToOrganizationButton
